import type { AbCheckRequest } from '../types';

export const AbCheckApi = Symbol.for('AbCheckApi');

/**
 * AB测试检查 API
 */
export interface AbCheckApi {
    /**
     * 检查指定功能的AB测试状态
     * @param functionName 功能名称
     * @param request 请求参数
     */
    checkAbTest(functionName: string,): Promise<boolean>;
}
